# TODO
# Visitor log, gaEvent
# console.log
# Mailchimp signup
# Reduce scripts/css
# Content in db?
# Extra styles - automatic
# Have JS class to match each page, by id?
# Build style page on server, css for style page
# Buy/Paypal stuff rendered on server?  CSS for Buy classes.
# Fast transition from collection to style page, filterHandler if do filter on collection page
# Stuff for ring size and necklace selectors in content.

window.console ?= {}
window.console.log ?= (->)

adminPreview = false

$(document).ready ->
  params = getURLParams()
  adminPreview = params && "preview" of params

window.isLdjAdmin = $ldj.isAdmin

enableTracking = true
displayTracking = true

# Website log (database)
visitorLog = (action, label) ->
  #return
  $.ajax
    url: "/visitors/request/create"
    type: 'POST'
    cache: false
    dataType: "json"
    data: {eventAction: action, eventLabel: label}
    success: (result) =>
    timeout: 3000
    error: (jqXHR, text, error) => 
      console.log "error", error


# Google Analytics
window.gaEvent = (action, label) ->
  #console.log("gaEvent", action, label, enableTracking) if displayTracking
  return unless enableTracking
  visitorLog(action, label)
  cat = if window.isLdjAdmin then "ldj (admin)" else "ldj"
  action = action + " (admin)" if window.isLdjAdmin
  _gaq?.push ["_trackEvent", cat, action, label]


# Facebook ad tracking - currently disabled
window.fbEvent = (styleId) =>
  return # Disable
  return unless enableTracking
  fb =
    "DN20": {id: "6036542189704", value: "180.00"}
    "DN20-G": {id: "6036542242704',", value: "210.00"}
  s = fb[styleId]
  if s
    console.log s
    window._fbq?.push(["track", s.id, {value: s.value, currency: "NZD"}])


# Site visit/exit events
gaEvent "siteVisit", window.location.pathname + (if document.referrer then " <-- #{document.referrer}" else "")
# Causing error in console?
#$(window).unload -> gaEvent("leaveSite", window.location.href)

# Underscore initialization
(->
  
  # Mustache style templating
  _.templateSettings =
    evaluate : /\{\[([\s\S]+?)\]\}/g      # {[ print('hello'); ]}
    interpolate : /\{\{([\s\S]+?)\}\}/g   # {{title}}
    escape: /\{\!([\s\S]+?)\!\}/g         # {!title!}
    
  # Add helper to underscore
  _.tmpl = (sel) -> _.template($(sel).html().trim())
  
)()

$.ajaxSetup
  headers:
    "X-CSRF-TOKEN": $("meta[name='csrf-token']").attr("content")

# Instantiate objects
$(document).ready ->
  
  new HomePage
  new JewelleryCollectionPage
  # Jewellery style page handled in style.coffee
  new AboutPage
  new StoresPage
  new PressPage
  #new BlogPage
  new ContactPage
  
  new FlexSlider
  new JewelleryInfo

#------ Pages ------#

class HomePage
  
  constructor: ->
    
    @page = $ "#home-page"
    return unless @page.length
    
    $(".featured-work a").click ->
      link = $(this)
      img = link.data "img"
      href = link.attr "href"
      gaEvent "clickHomeFeature", "#{img} #{href}"


class JewelleryCollectionPage
  
  constructor: ->
    
    # $ldj.jewellerySet is "botanics" if path is /jewellery/botanics
    # It is set by server/blade.
    
    @collectionPage = $ "#jewellery-collection-page"
    return unless @collectionPage and $ldj.jewellerySet?
    
    @jewellerySet = $ldj.jewellerySet
    
    @collectionWrapper = $ "#portfolio-wrapper"
    @filters = $ "#filters"
    @filterButtons = @filters.find "a"
    
    @initIsotope()
    
    @selectFilter @jewellerySet
    @filterButtons.click (evt) => @clickFilter($(evt.target))
      
    window.onpopstate = (event) =>
      @jewellerySet = @getCollectionNameFromPath()
      @selectFilter(@jewellerySet, true)
      
  initIsotope: ->
    @collectionWrapper.isotope
      itemSelector: '.portfolio-item'
      layoutMode: 'fitRows'
    #@collectionWrapper.isotope(filter: ".invalid")
  
  setPath: (path) ->
    @jewellerySet = path
    state = "/jewellery/#{path}" + (if adminPreview then "?preview" else "")
    window.history.pushState null, null, state
  
  getCollectionNameFromPath: ->
    path = window.location.pathname.split("/")[-1..]?[0]
    if path is "jewellery" then "" else path
    
  clickFilter: (filter) ->
    path = filter.data "path"
    #console.log "click on filter", path
    @setPath(path) if path isnt @jewellerySet  # Set if haven't clicked on current filter
  
  selectFilter: (path, setIsotope=false) ->
    filter = @filters.find "[data-path='#{path}']"
    return unless filter.length
    @filterButtons.removeClass "selected"  # Deselect all
    filter.addClass "selected"
    @collectionWrapper.isotope(filter: filter.data("option-value")) if setIsotope
    filter


class AboutPage
  
  constructor: ->
    
    @page = $ "#about-page"
    return unless @page.length
    
    # No actions
    


class StoresPage
  
  constructor: ->
    
    @page = $ "#stores-page"
    return unless @page.length
        
    $(".store-link")
      .attr target: "_blank"
      .click ->
        name = $(this).find(".store-name").text()
        gaEvent('clickStoreLink', name)


class PressPage
  
  constructor: ->
    
    @page = $ "#press-page"
    return unless @page.length
    
    @wrapper = $ ".press-wrapper"
    
    @press = $ "<div>",
      id: "rsPressGallery"  # Style defined in rs-ldj-custom.css
      class: "royalSlider rsDefault"
    .appendTo @wrapper
    
    for press in $ldj.press
      full = "/images/press/#{press.img}.jpg"
      thumb = "/images/press/thumbs/#{press.img}-thumb.jpg"
      slide = $ "<a>",
        class: "rsImg"
        dataSibling: full
        href: full
      thumb = $ "<img>", class: "rsTmb", src: thumb
      slide.append("<span>#{press.pub} &mdash; #{press.date}</span>").append(thumb)
      @press.append slide
    
    @press.royalSlider
      fullscreen: 
        enabled: true
        nativeFS: true
      controlNavigation: 'thumbnails'
      thumbs:
        orientation: 'horizontal'
        paddingBottom: 4
        appendSpan: true
      transitionType:'fade'
      autoScaleSlider: false #true
      autoScaleSliderWidth: 960
      autoScaleSliderHeight: 700
      loop: true
      arrowsNav: true
      keyboardNavEnabled: true
      navigateByClick: true
      arrowsNavAutoHide: true
      arrowsNavHideOnTouch: true
      globalCaption: true
      globalCaptionInside: false
    


class BlogPage
  
  constructor: ->
    
    @page = $ "#blog-page"
    return unless @page.length
    
    $(".blog-container").load -> $(".blog-loading").remove()


class ContactPage
  
  constructor: ->
    
    @page = $ "#contact-page"
    return unless @page.length
    
    ldjContactForm()  # In custom.js - ZZZ migrate to coffee
    
    $("#googlemaps").gMap(
      maptype: 'ROADMAP',
      scrollwheel: false,
      zoom: $ldj.contact.mapZoom,  #13, 14, 15
      markers: [
        address: $ldj.contact.address
        html: ''
        popup: false
      ]
    )


#------ Other widgets ------#

class FlexSlider
  
  constructor: ->
    
    @slider = $ ".flexslider"
    return unless @slider.length
    
    @slider.flexslider
      animation: "slide"
      initDelay: 20000
      slideshowSpeed: 8000
      multipleKeyboard: true
    
    @slider.removeClass "flex_loading"
    
    @images = @slider.find "img"
    
    @images.click (evt) =>
      link = $(evt.target).data "link"
      window.location = "/jewellery/#{link}"


class JewelleryInfo
  
  constructor: ->
    @linkToInfo = $ ".link-to-more-info"
    @moreInfo = $ ".more-info"
    @linkToInfo?.click => @moreInfo?.slideToggle(400)
    #gaEvent "clickMoreInfoButton", ""
    


# Dup code - see utils.coffee
getURLParams = ->
  s = window.location.search
  return null if not s
  s = s.slice(1) # Remove question mark
  args = s.split "&"
  props = []
  for a in args
    pv = a.split "="
    v = if pv.length is 1 then "null" else "\""+decodeURIComponent(pv[1])+"\""
    props.push "\"#{pv[0]}\": #{v}"
  obj = JSON.parse "{" + (props.join ", ") + "}"
